/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Exceptions from '@aws-sdk/client-bedrock-agent-runtime';

const exceptionMessageMap = {
  [Exceptions.InternalServerException.name]:
    'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es später erneut. Sollte das Problem bestehen bleiben, kontaktiere bitte den Administrator.',

  [Exceptions.BadGatewayException.name]:
    'Der Dienst ist momentan nicht erreichbar. Bitte versuche es später erneut. Sollte das Problem weiterhin bestehen, wende dich an den Administrator.',

  [Exceptions.DependencyFailedException.name]:
    'Ein technisches Problem ist aufgetreten. Bitte versuche es später erneut. Sollte das Problem bestehen bleiben, kontaktiere bitte den Administrator.',

  [Exceptions.ThrottlingException.name]:
    'Zu viele Anfragen in kurzer Zeit. Bitte warte einen Moment und versuche es dann erneut.',

  [Exceptions.ServiceQuotaExceededException.name]:
    'Das Anfrage-Limit wurde erreicht. Bitte warte kurz und versuche es erneut. Sollte das Problem fortbestehen, kontaktiere den Administrator.',

  [Exceptions.ValidationException.name]:
    'Die Eingabe war ungültig. Bitte überprüfe deine Angaben und versuche es erneut.',

  [Exceptions.AccessDeniedException.name]:
    'Zugriff verweigert. Du hast keine Berechtigung für diese Aktion. Wende dich bei Fragen bitte an den Administrator.',

  [Exceptions.ResourceNotFoundException.name]:
    'Ein erforderlicher Bestandteil wurde nicht gefunden. Bitte überprüfe deine Eingabe oder kontaktiere den Administrator.',

  [Exceptions.ModelNotReadyException.name]:
    'Das System ist noch nicht vollständig bereit. Bitte warte einen Moment und versuche es erneut.',

  [Exceptions.ConflictException.name]:
    'Ein interner Konflikt ist aufgetreten. Bitte versuche es erneut. Sollte das Problem weiterhin bestehen, kontaktiere bitte den Administrator.',
};

export function getUserErrorMessage(err: unknown): string {
  const name = (err as any)?.name;
  const fallback = 'Service derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.';

  if (name && '_' + name in exceptionMessageMap) {
    return exceptionMessageMap['_' + name];
  }

  if (err instanceof Error) {
    return 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.';
  }

  return fallback;
}
